import { baseApi } from '@app/store/index.api';

import {
  IMetabaseChartResponse,
  IMetabaseChartQuery,
  IMetabaseDashboardLinkResponse,
} from '../model/types';

const metabaseApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getDashboardLink: builder.query<IMetabaseDashboardLinkResponse, undefined>({
      query: () => {
        return {
          url: '/merchants/analytics',
        };
      },
    }),
    getMetabaseChart: builder.query<IMetabaseChartResponse, IMetabaseChartQuery>({
      query: ({ question_id }) => {
        return {
          url: '/dashboard/metabase',
          method: 'GET',
          params: {
            question_id,
          },
        };
      },
    }),
  }),
});

export const { useGetDashboardLinkQuery, useGetMetabaseChartQuery } = metabaseApi;
